module.exports = __webpack_public_path__ + "static/media/bo-cong-thuong.4e048bd2.svg";